import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';

import { AppSidebarService } from './app-sidebar.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Component({
    selector: 'app-sidebar-minimizer, cui-sidebar-minimizer',
    template: `<div class="_wf-pp-footertext paddinginlogofordesktopview">
    <div class="_wf-pp-footericon">
      @if (!appService.isNotHealth()) {
        <img alt=""  loading="lazy" src="assets/images/logo-powered-reverse.svg">
      }
      @if (appService.isNotHealth() && domainPlatform) {
        <img alt=""  loading="lazy" [src]="utilService.getImageUrl(domainPlatform.footer_logo)">
      }
    </div>
  </div>`,
    standalone: false
})
export class AppSidebarMinimizerComponent implements OnInit {
  public domainPlatform:any = false;
  @HostBinding('attr.role') @Input() role = 'button';
  @HostBinding('class.sidebar-minimizer') _minimizer = true;

  @HostListener('click', ['$event'])
  toggleOpen($event: any) {
    $event.preventDefault();
    this.sidebarService.toggle({minimize: 'toggle'});
    window.dispatchEvent(new Event('resize'));
  }

  constructor(
    private sidebarService: AppSidebarService,
    public utilService:UtilService,
    public appService:AppService
  ) { }

  ngOnInit(){
    this.domainPlatform = this.appService.getCurrentSupperAppObject();
  }
}
